@if (isUnified) {
  <!-- Unified Code: learning paths as the standard card grid (criterion 28), each card with a CTA. -->
  <section *ngIf="carouselResize.data.length" class="uc-home-section" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="uc-home-section__header">
        <h2 class="uc-home-section__title uc-display-sm" translate="home.paths"></h2>
        <p *ngIf="description" class="uc-home-section__lead uc-text-lg">{{ description }}</p>
      </div>
      <ul class="uc-card-grid">
        <li *ngFor="let item of carouselResize.data.slice(0, 8)">
          <app-course-item [path]="item"></app-course-item>
        </li>
      </ul>
      <div class="uc-home-section__more">
        <a class="uc-see-more" routerLink="/course" translate="home.seeMore"></a>
      </div>
    </div>
  </section>
} @else {
<section *ngIf="carouselResize.data.length">
    <div class="container py-5">
        <div class="row row-cols-1 row-cols-lg-2 gy-5 gy-lg-0 align-middle">
            <div class="col px-lg-0 order-1 order-lg-0">
                <app-custom-carousel #appCustomCarousel [content]="trainingCentersContent" [carouselResize]="carouselResize" (shareIndex)="carouselResize.currentIndex = $event"></app-custom-carousel>
            </div>
            <div class="col order-0 order-lg-1 align-self-center" [class]="isRtl ? 'text-end' : 'text-start'">
                <h2 class="home-titles mb-4" translate="home.paths"></h2>
                <span class="d-block mb-2">{{"home.pathsCount" | translate}} {{carouselResize.data.length}}</span>
                <p>{{description}}</p>
                <div class="text-center mt-4">
                    <a class="btn btn-see-more border rounded-pill px-3 py-2" routerLink="/course" translate="home.seeMore"></a>
                </div>
            </div>
        </div>
    </div>
    <ng-template #trainingCentersContent>
        <div class="carousel-container w-100 position-relative overflow-hidden">
            <ng-container *ngFor="let slide of carouselResize.items; track i; let i = index">
                <div class="carousel-slide py-2 px-3 w-100 h-100 position-absolute" [ngStyle]="{left: 'calc('+ i +'*100%)', transform: 'translateX(-'+ carouselResize.currentIndex +'00%)'}">
                    <div class="d-flex flex-wrap align-items-md-center" [ngClass]="{'flex-column justify-content-between': slide.length >= 3, 'flex-row justify-content-center': slide.length < 3}">
                        <div class="h-50 px-2" *ngFor="let item of slide; let i = index" [ngClass]="slide.length > 2 ? 'path-'+(i + 1) : 'path-'+(i === 0 ? 1 : 3)">
                            <a [routerLink]="['/learning-path/details', item.id]">
                                <div class="training-paths-card bg-white border border-2 overflow-hidden">
                                    <div [dir]="isRtl ? 'rtl' : 'ltr'" class="training-paths-card-caption overflow-hidden">
                                        <h3>{{isRtl? item.nameAr : item.name}}</h3>
                                        <p>{{isRtl? item.description: item.descriptionLang}}</p>
                                    </div>
                                    <div class="training-paths-card-img bg-white">
                                        <img loading="lazy" class="w-100 h-100 object-fit-cover" [src]="mediaUrl + item.image" [alt]="isRtl ? item.nameAr : item.name">
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-template>
</section>
}
